<template>
  <div class="header henan">
    <div class="header_top">
      <div class="top_left">
        <p>
          <span @click="canyou" class="cursorP">启用无障碍浏览</span>
<!--          <i class="line"></i>-->
<!--          <span><a href="https://www.cdpf.org.cn/" target="_blank">中国残疾人联合会</a></span>-->
<!--          <i class="line"></i>-->
<!--          <span><a href="https://www.hebei.gov.cn/" target="_blank">河北省人民政府</a></span>-->
        </p>
      </div>
      <div class="top_right">
        <a href="javascript:void(0);" @click="close = true"><i class="el-icon-location"></i>{{ locationText }} 切换站点</a>
        <a href="javascript:void(0);"><i class="el-icon-message-solid"></i>消息</a>
        <div class="login relative mright" @mouseover="loginAlert = true" v-if="!isLogin">
          <div class="login flex mright">登录/注册</div>
          <div class="weimu" v-show="loginAlert" @click="loginAlert = false">
          </div>
          <div class="login_alert" v-show="loginAlert">
            <el-button type="primary" @click="goRouters('/Login/')"><img src="@/static/login/user1.png" alt=""/>我要求职
            </el-button>
            <el-button type="primary" class="blue" @click="goRouters('/user/companyLogin')"><img
                src="@/static/login/company1.png" alt=""/>我要招聘
            </el-button>
            <a href="https://admin.cdpee.org.cn/" target="_blank" @click="loginAlert = false">
              <el-button type="waring" class="org"><img src="@/static/login/jigou1.png" alt=""/>机构登录
              </el-button>
            </a>
          </div>
        </div>
        <div class="login flexs" v-else>
          <HeadDrop></HeadDrop>
        </div>
      </div>
    </div>
    <div class="logo">
      <img src="@/static/hebei/logo1.png" alt="">
    </div>
    <div class="header_content">
      <div class="box">
        <el-menu :default-active="activeIndex" class="el-menu-demo tab_el_memu" mode="horizontal" :router="true"
                 v-if="!isLogin || isLogin.userType != 2">
          <el-menu-item index="/">
            <!--   @click="getData"-->
            <div class="li">首页</div>
          </el-menu-item>
          <el-menu-item index="/job/">
            <div class="li">求职招聘</div>
          </el-menu-item>
          <el-menu-item index="/train/">
            <div class="li">职业培训</div>
          </el-menu-item>
          <!-- <el-menu-item index="/public/onlineJobfair/">
            <div class="li">专场招聘</div>
          </el-menu-item> -->
          <el-menu-item index="/create/">
            <div class="li">创业项目</div>
          </el-menu-item>
          <el-menu-item index="/specialSchools">
            <div class="li">特教学校</div>
          </el-menu-item>
          <el-menu-item index="/new/">
            <div class="li">新闻资讯</div>
          </el-menu-item>

          <el-menu-item index="/mangan">
            <div class="li">盲人按摩</div>
          </el-menu-item>
          <el-menu-item index="/skill/">
            <div class="li">技能竞赛</div>
          </el-menu-item>
          <el-menu-item index="/new/people_list/">
            <div class="li">残疾人风采</div>
          </el-menu-item>
        </el-menu>
        <el-menu :default-active="activeIndex" class="el-menu-demo tab_el_memu" mode="horizontal" :router="true" v-else
                 @select="handleSelect">
          <el-menu-item index="/enterprise">
            <div class="li">首页</div>
          </el-menu-item>
          <el-menu-item index="/enterprise/post">
            <div class="li">职位管理</div>
          </el-menu-item>
          <!-- <el-menu-item index="/skill/">
            <div class="li">技能竞赛</div>
          </el-menu-item>
          <el-menu-item index="/create/">
            <div class="li">残疾人创业</div>
          </el-menu-item> -->
          <el-menu-item index="/enterprise/recruiting">
            <div class="li">找人才</div>
          </el-menu-item>
          <el-menu-item index="/enterprise/netJob">
            <div class="li">网络招聘会</div>
          </el-menu-item>
          <el-menu-item index="/enterprise/resumes">
            <div class="li">简历管理</div>
          </el-menu-item>
          <el-menu-item index="/enterprise/videointerview">
            <div class="li">视频面试管理</div>
          </el-menu-item>

        </el-menu>
      </div>
    </div>
    <city :show="close" width="1000px" @close="close = false"></city>
    <el-dialog title="" :visible.sync="isHide" width="360px" :before-close="handleClose">
      <div class="el_content">
      </div>
    </el-dialog>
    <disLogin :goShow="isHideLogin" @close="handleClose" title="河北残联登录" text="河北残联登录"></disLogin>
  </div>
</template>

<script>
import city from '@/components/search/allCity'
import HeadDrop from '../../public/HeadDrop'
import disLogin from '@/components/login/disLogin'

export default {
  name: 'Header',
  inject: ['reload'],
  render(createElement, context) {
  },
  props: {
    index: '',
  },
  components: {
    city,
    HeadDrop,
    disLogin,
  },
  data() {
    return {
      close: false,
      activeIndex: this.$route.path || '',
      status: 1,
      logo: '', //头部登录logo
      type: 1,
      isHide: false,
      isHideLogin: false,
      isLogin: '',
      loginAlert: false,
      locationText: '河北省'
    }
  },
  methods: {
    async getData() {
      let res = await this.$api.hunanUpdateSiteDataApi()
    },
    handleSelect(key, keyPath) {
      this.reload()
    },
    handleClose() {
      this.isHide = false
      this.loginAlert = false
      this.isHideLogin = false
    },
    goRouters(url) {
      this.$router.push(url)
    },
    goRouters1() {
      if (this.isLogin.userType == "2") {
        this.$router.push('/enterprise')
        this.reload()
      } else {
        this.$router.push('/')
      }
    },
    //无障碍
    canyou() {
      window.toolbar.open()
    },
  },
  created() {
    if (this.$store.state.userType || localStorage.getItem('userInfo')) {
      this.isLogin =
          this.$store.state.userType ||
          JSON.parse(localStorage.getItem('userInfo'))
    }
    this.locationText = localStorage.getItem('locationText') || '河北省';
    setTimeout(() => {
      console.log(this.index, this.$route.path)
      this.activeIndex = this.index || this.$route.path
    }, 10)
  },
}
</script>

<style scoped lang="less">
.header {
  background: url("~static/hebei/header_bg.png") center top no-repeat;
  background-size: 100% auto;
  height: 355px;

  .header_top {
    display: flex;
    width: 1200px;
    margin: 0 auto;
    padding-top: 20px;
    justify-content: space-between;

    .top_left {
      p {
        display: flex;

        i {
          width: 1px;
          height: 16px;
          background: white;
          margin: 3px 8px 0 8px;
        }

        span, a {
          font-family: PingFangSC-Medium;
          font-weight: 500;
          font-size: 16px;
          color: #FFFFFF;
          letter-spacing: 0.47px;
          text-shadow: 0 2px 4px #00000033;
        }
      }
    }

    .top_right {
      display: flex;

      i {
        margin-right: 4px;
      }

      a {
        margin-right: 24px;
      }

      a, div {
        font-family: PingFangSC-Medium;
        font-weight: 500;
        font-size: 16px;
        color: #FFFFFF;
        letter-spacing: 0.47px;
        text-shadow: 0 2px 4px #00000033;
      }
    }
  }

  .logo {
    width: 1200px;
    margin: 64px auto 0 auto;
  }

  .header_content {
    width: 1200px;
    margin: 44px auto 0 auto;

    .box {
      background: #FFFFFF;
      box-shadow: 0 4px 4px 0 #00000008;
      border-radius: 6px;
      padding: 12px 18px;

      /deep/ .tab_el_memu {
        display: flex;
        border: none;

        .el-menu-item:hover {
          color: #28a46d;
          font-weight: 600;
        }

        .el-menu-item {
          display: flex;
          flex: 1;
          color: #333333;
          padding: 0;
          height: auto;
          line-height: initial;

          .li {
            height: auto;
            padding: 10px 20px;
            border-radius: 6px;
            font-family: PingFangSC-Regular;
            font-weight: 600;
            font-size: 18px;
            color: #333333;
            letter-spacing: 0.53px;
            text-align: center;
          }
        }

        .el-menu-item.is-active {
          color: white;
          border: none;
          background: transparent;
          .li {
            font-weight: 600;
            color: white;
            background: #28a46d;
            box-shadow: 1px 4px 10px rgba(40, 164, 109, 0.3);
          }
        }

        .el-menu-item:after,
        .el-menu-item.is-active:after {
          display: none;
        }
      }
    }
  }

  .el-menu--horizontal .el-menu .el-menu-item,
  .el-menu--horizontal .el-menu .el-submenu__title {
    color: #00924b;
  }
}

.imgs {
  width: 30px;
  height: 30px;
  display: block;
  margin-right: 16px;
  border-radius: 50%;
}

.el-icon-caret-bottom {
  color: #333333;
}

.login_alert {
  position: absolute;
  right: -30px;
  width: 306px;
  padding: 30px;
  background: white;
  border-radius: 0 0 6px 6px;
  z-index: 10000;

  .el-button {
    width: 246px;
    height: 42px;
    line-height: 42px;
    padding: 0;
    margin-left: 0;
    margin-bottom: 24px;
    border: none;

    img {
      width: 18px !important;
      height: 18px !important;
      vertical-align: middle;
      transform: translateY(-1px);
      margin-right: 5px;
    }
  }

  .blue {
    background: #0090e2;
  }

  .org {
    margin-bottom: 0;
    color: white;
    background: #ff9600;
  }
}

.weimu {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  z-index: 999;
}
</style>
